import React, { useState } from 'react';
import ChatWindow from './ChatWindow';
import '../styles/ChatWidget.css';

const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="chat-widget">
      {isOpen && (
        <ChatWindow onClose={() => setIsOpen(false)} />
      )}
      
      <button 
        className="chat-toggle-btn"
        onClick={toggleChat}
        title="Asistente Zeta"
      >
        {isOpen ? '✕' : '💬'}
      </button>
    </div>
  );
};

export default ChatWidget;
